import React from "react";
import {Link, Typography} from "@bonprix/design-system";

export default function OtherCategories({otherCategories, texts}) {
    return (
        <div className='other-categories w-full pb-12 px-2 l:px-0' >
            <div className="mb-5">
                <Typography variant="bonprix-h5" component="div">{texts.other_categories_title}</Typography>
            </div>
            <div className="other-categories__link-container typography-body1">
                {otherCategories.map((category, index) => (
                    <div className="flex-shrink-0 mr-5 last:mr-0" key={`other-category-${index}`}>
                        <Link
                            arrowPosition='right'
                            href={category.path}
                            showArrow
                            hideUnderline
                        >
                            {category.text}
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
}
